import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "leaderboard-banner__glow",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_2 = { class: "leaderboard-banner__content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "leaderboard-banner__logo",
  src: "media/leaderboard/agg-logo.png",
  alt: "AGG"
}, null, -1)
const _hoisted_4 = { class: "leaderboard-banner__badge" }
const _hoisted_5 = { class: "leaderboard-banner__title" }
const _hoisted_6 = { class: "leaderboard-banner__description" }
const _hoisted_7 = { class: "leaderboard-banner__art" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["leaderboard-banner", _ctx.bannerClass]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.banner.badge), 1),
      _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.banner.title), 1),
      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.banner.description), 1)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("img", {
        src: _ctx.banner.heroImage,
        alt: _ctx.banner.title,
        class: "leaderboard-banner__hero"
      }, null, 8, ["src", "alt"]),
      (_ctx.banner.accentImage)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            src: _ctx.banner.accentImage,
            alt: "",
            class: "leaderboard-banner__accent",
            "aria-hidden": "true"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}